import React, { useEffect, useState } from 'react';
import TutorialMessage from '../../components/TutorialMessage';
import translate from '../../utilities/translator';

export default function DatesTutorial() {
  const [showTutorial, setShowTutorial] = useState(true);
  const messageTimeout = localStorage.getItem('datesTutorialMessageTimeout');

  useEffect(() => {
    const nowTimestamp = +new Date();
    if (messageTimeout && ((nowTimestamp - messageTimeout) / (3600000 * 24)) < 30) {
      setShowTutorial(false)
    }
  },[messageTimeout]);

  const hideMessage = () => {
    setShowTutorial(false);
    localStorage.setItem('datesTutorialMessageTimeout', (+new Date()));
  };


  return (
    <TutorialMessage
      message={translate('holidayFinder.tutorial.dates')}
      onHideClick={hideMessage}
      show={showTutorial}
      buttonType="small"
      className="mb-2"
    />
  );
}
